import React from "react";
import "./lawyerCTA.css";
import { useNavigate } from "react-router-dom";

// Import your image here
import legalImage from "./assets/ctaImage.png";

const LawyerCTA = () => {
  const navigate = useNavigate();
  return (
    <div className="legal-connect-container">
      <div className="legal-connect-content">
        <div className="legal-connect-left">
          <img
            src={legalImage}
            alt="Legal Professional"
            className="legal-connect-image"
          />
        </div>
        <div className="legal-connect-right">
          <span className="legal-connect-badge">For Law Practices</span>
          <h2 className="legal-connect-heading">Grow Your Practice with Quidpro LegalConnect</h2>
          <p className="legal-connect-subtitle">Are you a legal professional eager to attract new clients?</p>
          <ul className="legal-connect-list">
            <li>
              <span className="list-icon">✓</span>
              Reach local clients actively seeking legal expertise
            </li>
            <li>
              <span className="list-icon">✓</span>
              Optimize your schedule with last-minute consultation bookings
            </li>
            <li>
              <span className="list-icon">✓</span>
              Build your credibility through verified client reviews
            </li>
            <li>
              <span className="list-icon">✓</span>
              Enhance your online presence with AI-powered visibility
            </li>
          </ul>
          <div className="hero-cta-row">
            <button
              className="legal-connect-btn legal-connect-btn-primary"
              onClick={() => {
                navigate("/grow/sign-up");
              }}
            >
              List your practice on Quidpro
            </button>
            <button
              className="legal-connect-btn legal-connect-btn-secondary"
              onClick={() => navigate("/grow/attorney")}
            >
              Learn more →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LawyerCTA;
